var exports = {
  "Qs": "AddGuildModal.module__content___SDF6bU",
  "lF": "AddGuildModal.module__footerReveal___SDF6bU",
  "BT": "AddGuildModal.module__landingContainer___SDF6bU",
  "Xg": "AddGuildModal.module__actionButtonsGroup___SDF6bU",
  "uu": "AddGuildModal.module__actionButtons___SDF6bU",
  "hP": "AddGuildModal.module__actionButton___SDF6bU",
  "gE": "AddGuildModal.module__actionIcon___SDF6bU",
  "ZJ": "AddGuildModal.module__actionLabel___SDF6bU",
  "KJ": "AddGuildModal.module__formContainer___SDF6bU",
  "r2": "AddGuildModal.module__iconSection___SDF6bU",
  "ff": "AddGuildModal.module__iconSectionInner___SDF6bU",
  "go": "AddGuildModal.module__iconLabel___SDF6bU",
  "O2": "AddGuildModal.module__iconPreview___SDF6bU",
  "Dp": "AddGuildModal.module__iconImage___SDF6bU",
  "Pz": "AddGuildModal.module__iconPlaceholder___SDF6bU",
  "Ne": "AddGuildModal.module__iconInitials___SDF6bU",
  "D_": "AddGuildModal.module__iconActions___SDF6bU",
  "Nu": "AddGuildModal.module__iconButtons___SDF6bU",
  "m5": "AddGuildModal.module__iconError___SDF6bU",
  "I4": "AddGuildModal.module__guidelines___SDF6bU",
  "YC": "AddGuildModal.module__guidelinesLink___SDF6bU",
  "$J": "AddGuildModal.module__templatePreview___SDF6bU",
  "pT": "AddGuildModal.module__templateInfo___SDF6bU",
  "x7": "AddGuildModal.module__templateLabel___SDF6bU",
  "G": "AddGuildModal.module__templateName___SDF6bU",
  "qt": "AddGuildModal.module__templateStats___SDF6bU",
  "W4": "AddGuildModal.module__openApiUrlButton___SDF6bU",
  "OJ": "AddGuildModal.module__verificationNotice___SDF6bU",
};

module.exports = exports;
